import { connect } from 'react-redux'

import appSelectors from 'App/duck/selectors'

import InboxSelectors from '../../duck/selectors'
import InboxFlyout from './InboxFlyout.component'

const mapStateToProps = (state): any => {
  const isOpen = InboxSelectors.getIsOpen(state)
  const isLargeScreen = appSelectors.getIsDesktop(state)

  return {
    isOpen,
    isLargeScreen,
  }
}

export default connect(mapStateToProps)(InboxFlyout)
